module.exports = __webpack_public_path__ + "static/media/ordini5n.ca64b855.png";